import React from 'react';
import GlobalContext, { Redirects } from './GlobalContext';
import MainBusinesses from './businessareas';
import FourZeroFour from './fourzerofour';
import HeaderMin from './headermin';

const RequestResult = (props) => {
    const paths = GlobalContext().paths;
    console.log(props.match.params.result);

    if (props.match.params.result === "0") {
        return (
            <FourZeroFour />
        )
    }

    return (
        <>
            <HeaderMin />
            <div className="container">
                <div className="text-center">
                    <br />
                    <br />
                    <h1><strong>SUCCESS!</strong></h1>
                </div>
                <p className="text-center">Your request was successfully sent.<br />
             Thank you for reaching out to us.<br />
              A sales representative will contact you shortly.</p>

                <div className="d-flex justify-content-center">
                    <a href="javascript:history.back()">
                        <div className="btn_search ">
                            <svg className="searchresult" version="1.1" id="Layer_1" x="0px" y="0px"
                                viewBox="0 0 320 320" >
                                <path d="M282.6,139.5c0,40.2-32.7,72.6-72.6,72.6v-33.7c21.5,0,38.9-17.4,38.9-38.9s-17.4-38.9-38.9-38.9H102l30.8,30.8L109,155.2
	L37.4,83.5L108.9,12l23.8,23.8l-30.8,30.8h107.8C249.9,66.7,282.6,99.3,282.6,139.5z"/>
                                <g>
                                    <path d="M103.9,252.4c2.5,0,4.6,0.2,6.4,0.7s3.3,1.2,4.4,2.1c1.2,0.9,2,2,2.6,3.3c0.5,1.3,0.8,2.8,0.8,4.4
		c0,1-0.2,2-0.5,2.9c-0.3,0.9-0.8,1.8-1.4,2.6c-0.6,0.8-1.4,1.5-2.4,2.1c-1,0.6-2.1,1.1-3.3,1.5c3,0.6,5.2,1.6,6.7,3.2
		s2.2,3.6,2.2,6.1c0,1.7-0.3,3.3-0.9,4.7c-0.6,1.4-1.6,2.6-2.8,3.6c-1.2,1-2.7,1.8-4.5,2.4c-1.8,0.6-3.8,0.8-6,0.8H91v-40.5H103.9z
		 M96.5,256.7v13.8h7.2c1.5,0,2.9-0.2,4-0.5s2.1-0.8,2.8-1.4c0.7-0.6,1.3-1.3,1.7-2.2c0.4-0.9,0.5-1.8,0.5-2.8
		c0-2.4-0.7-4.1-2.1-5.2c-1.4-1.1-3.7-1.7-6.7-1.7H96.5z M105.2,288.5c1.6,0,2.9-0.2,4-0.5s2.1-0.9,2.8-1.5c0.7-0.6,1.3-1.4,1.6-2.3
		s0.5-1.9,0.5-3c0-2.1-0.7-3.7-2.2-5c-1.5-1.2-3.7-1.8-6.7-1.8h-8.8v14.1H105.2z"/>
                                    <path d="M159.8,292.8h-4.2c-0.5,0-0.9-0.1-1.2-0.4c-0.3-0.2-0.5-0.6-0.7-0.9l-3.8-9.8h-18.2l-3.8,9.8
		c-0.1,0.3-0.3,0.6-0.6,0.9c-0.3,0.3-0.7,0.4-1.2,0.4H122l16.2-40.5h5.5L159.8,292.8z M148.4,277.8l-6.4-16.5
		c-0.2-0.5-0.4-1.1-0.6-1.7s-0.4-1.3-0.6-2.1c-0.4,1.5-0.8,2.8-1.2,3.8l-6.4,16.4H148.4z"/>
                                    <path d="M192.5,284.5c0.3,0,0.6,0.1,0.8,0.4l2.2,2.3c-1.7,1.9-3.7,3.4-6,4.5c-2.4,1.1-5.2,1.6-8.6,1.6
		c-2.9,0-5.5-0.5-7.9-1.5s-4.4-2.4-6.1-4.2c-1.7-1.8-3-4-3.9-6.5c-0.9-2.5-1.4-5.3-1.4-8.4c0-3,0.5-5.8,1.4-8.4s2.3-4.7,4.1-6.5
		c1.7-1.8,3.8-3.2,6.3-4.2c2.4-1,5.1-1.5,8-1.5c2.9,0,5.4,0.5,7.6,1.4c2.2,0.9,4.1,2.2,5.8,3.8l-1.8,2.5c-0.1,0.2-0.3,0.3-0.4,0.5
		c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0-0.8-0.2-1.2-0.6c-0.5-0.4-1.1-0.8-1.9-1.2c-0.8-0.5-1.8-0.9-3-1.2s-2.6-0.6-4.4-0.6
		c-2.1,0-4,0.4-5.7,1.1c-1.7,0.7-3.2,1.8-4.5,3.1s-2.2,3-2.9,5c-0.7,2-1,4.2-1,6.7c0,2.5,0.4,4.8,1.1,6.7c0.7,2,1.7,3.6,3,5
		c1.3,1.4,2.7,2.4,4.4,3.1c1.7,0.7,3.5,1.1,5.5,1.1c1.2,0,2.3-0.1,3.3-0.2s1.9-0.4,2.7-0.7c0.8-0.3,1.6-0.7,2.3-1.1
		c0.7-0.5,1.4-1,2.1-1.7C191.9,284.6,192.2,284.5,192.5,284.5z"/>
                                    <path d="M207.3,270.1h2.1c0.7,0,1.3-0.1,1.7-0.3c0.4-0.2,0.8-0.5,1.2-0.9l13.5-15.2c0.4-0.5,0.8-0.8,1.2-1
		c0.4-0.2,0.9-0.3,1.5-0.3h4.6l-15.4,17.4c-0.4,0.5-0.7,0.8-1.1,1.1c-0.3,0.3-0.7,0.5-1.1,0.7c0.5,0.2,1,0.4,1.4,0.7
		s0.8,0.8,1.2,1.3l16.1,19.2h-4.7c-0.4,0-0.7,0-0.9-0.1s-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.1-0.3-0.3-0.4-0.5
		L213,275.6c-0.4-0.5-0.8-0.8-1.2-1c-0.4-0.2-1.1-0.3-2-0.3h-2.5v18.5h-5.4v-40.5h5.4V270.1z"/>
                                </g>
                            </svg>
                        </div>
                    </a>
                    <a href="/search">
                        <div className="btn_search ">
                            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                                viewBox="0 0 320 320" >

                                <path d="M260,190.4l-53.3-53.3c8.4-12.7,13.3-27.8,13.3-44.1c0-44.2-35.8-80-80-80c-44.2,0-80,35.8-80,80c0,44.2,35.8,80,80,80
	c16.3,0,31.5-4.9,44.1-13.3l53.3,53.3L260,190.4z M82.7,93c0-31.7,25.7-57.3,57.3-57.3c31.7,0,57.3,25.7,57.3,57.3
	c0,31.7-25.7,57.3-57.3,57.3C108.3,150.4,82.7,124.7,82.7,93z"/>
                                <g>
                                    <path class="st0" d="M77.2,258.7c-0.2,0.3-0.4,0.5-0.6,0.6c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0-0.7-0.2-1.1-0.5
		c-0.4-0.3-1-0.7-1.6-1.1c-0.6-0.4-1.4-0.7-2.3-1.1c-0.9-0.3-2-0.5-3.3-0.5c-1.2,0-2.3,0.2-3.2,0.5s-1.7,0.8-2.3,1.3
		c-0.6,0.6-1.1,1.2-1.4,2c-0.3,0.8-0.5,1.6-0.5,2.5c0,1.1,0.3,2.1,0.8,2.8s1.3,1.4,2.2,1.9c0.9,0.5,1.9,1,3.1,1.4
		c1.2,0.4,2.3,0.8,3.6,1.2s2.4,0.9,3.6,1.4c1.2,0.5,2.2,1.2,3.1,2s1.6,1.8,2.2,2.9c0.6,1.1,0.8,2.6,0.8,4.2c0,1.8-0.3,3.4-0.9,5
		c-0.6,1.6-1.5,2.9-2.6,4.1c-1.2,1.1-2.6,2.1-4.3,2.7c-1.7,0.7-3.6,1-5.7,1c-2.6,0-5-0.5-7.2-1.4s-4-2.2-5.5-3.9l1.6-2.6
		c0.2-0.2,0.3-0.4,0.6-0.5c0.2-0.1,0.5-0.2,0.7-0.2c0.2,0,0.5,0.1,0.8,0.3s0.7,0.4,1.1,0.7c0.4,0.3,0.8,0.6,1.4,1
		c0.5,0.4,1.1,0.7,1.7,1s1.4,0.5,2.2,0.7c0.8,0.2,1.8,0.3,2.8,0.3c1.3,0,2.5-0.2,3.5-0.5s1.9-0.9,2.6-1.5c0.7-0.6,1.2-1.4,1.6-2.3
		c0.4-0.9,0.6-1.9,0.6-3c0-1.2-0.3-2.2-0.8-3c-0.6-0.8-1.3-1.4-2.2-2c-0.9-0.5-1.9-1-3.1-1.3c-1.2-0.4-2.4-0.7-3.6-1.1
		c-1.2-0.4-2.4-0.8-3.6-1.3c-1.2-0.5-2.2-1.2-3.1-2c-0.9-0.8-1.6-1.8-2.2-3c-0.6-1.2-0.8-2.7-0.8-4.5c0-1.4,0.3-2.8,0.8-4.2
		c0.6-1.3,1.4-2.5,2.4-3.6c1.1-1,2.4-1.9,3.9-2.5s3.3-0.9,5.3-0.9c2.3,0,4.3,0.4,6.2,1.1c1.9,0.7,3.5,1.8,4.9,3.1L77.2,258.7z"/>
                                    <path class="st0" d="M112.1,288.4l0,4.5H87.1v-40.5h24.9v4.5H92.6v13.4h15.8v4.3H92.6v13.8H112.1z" />
                                    <path class="st0" d="M152.6,292.8h-4.2c-0.5,0-0.9-0.1-1.2-0.4c-0.3-0.2-0.5-0.6-0.7-0.9l-3.8-9.8h-18.2l-3.8,9.8
		c-0.1,0.3-0.3,0.6-0.6,0.9c-0.3,0.3-0.7,0.4-1.2,0.4h-4.2l16.2-40.5h5.5L152.6,292.8z M141.2,277.8l-6.4-16.5
		c-0.2-0.5-0.4-1.1-0.6-1.7s-0.4-1.3-0.6-2.1c-0.4,1.5-0.8,2.8-1.2,3.8l-6.4,16.4H141.2z"/>
                                    <path class="st0" d="M187.9,292.8H183c-1,0-1.7-0.4-2.2-1.2l-10.5-14.5c-0.3-0.5-0.7-0.8-1-1c-0.4-0.2-0.9-0.3-1.7-0.3h-4.1v16.9
		H158v-40.5h11.4c2.6,0,4.8,0.3,6.6,0.8c1.9,0.5,3.4,1.3,4.6,2.2c1.2,1,2.1,2.2,2.7,3.5c0.6,1.4,0.9,2.9,0.9,4.6
		c0,1.4-0.2,2.8-0.7,4s-1.1,2.4-2,3.3c-0.9,1-1.9,1.8-3.1,2.5c-1.2,0.7-2.6,1.2-4.2,1.6c0.7,0.4,1.3,1,1.8,1.7L187.9,292.8z
		 M169.2,272c1.6,0,3-0.2,4.2-0.6c1.2-0.4,2.2-0.9,3-1.6c0.8-0.7,1.4-1.5,1.8-2.5c0.4-1,0.6-2.1,0.6-3.2c0-2.4-0.8-4.2-2.4-5.4
		c-1.6-1.2-4-1.8-7.1-1.8h-6V272H169.2z"/>
                                    <path class="st0" d="M221.3,284.5c0.3,0,0.6,0.1,0.8,0.4l2.2,2.3c-1.7,1.9-3.7,3.4-6,4.5c-2.4,1.1-5.2,1.6-8.6,1.6
		c-2.9,0-5.5-0.5-7.9-1.5c-2.4-1-4.4-2.4-6.1-4.2s-3-4-3.9-6.5c-0.9-2.5-1.4-5.3-1.4-8.4c0-3,0.5-5.8,1.4-8.4c1-2.5,2.3-4.7,4.1-6.5
		c1.7-1.8,3.8-3.2,6.3-4.2c2.4-1,5.1-1.5,8-1.5c2.9,0,5.4,0.5,7.6,1.4c2.2,0.9,4.1,2.2,5.8,3.8l-1.8,2.5c-0.1,0.2-0.3,0.3-0.4,0.5
		s-0.4,0.2-0.7,0.2c-0.3,0-0.8-0.2-1.2-0.6s-1.1-0.8-1.9-1.2c-0.8-0.5-1.8-0.9-3-1.2s-2.6-0.6-4.4-0.6c-2.1,0-4,0.4-5.7,1.1
		c-1.7,0.7-3.2,1.8-4.5,3.1c-1.3,1.4-2.2,3-2.9,5c-0.7,2-1,4.2-1,6.7c0,2.5,0.4,4.8,1.1,6.7c0.7,2,1.7,3.6,3,5
		c1.3,1.4,2.7,2.4,4.4,3.1c1.7,0.7,3.5,1.1,5.5,1.1c1.2,0,2.3-0.1,3.3-0.2c1-0.1,1.9-0.4,2.7-0.7s1.6-0.7,2.3-1.1
		c0.7-0.5,1.4-1,2.1-1.7C220.7,284.6,221,284.5,221.3,284.5z"/>
                                    <path class="st0" d="M263.4,252.4v40.5H258v-18.4h-21.8v18.4h-5.5v-40.5h5.5v18H258v-18H263.4z" />
                                </g>
                            </svg>
                        </div>

                    </a>
                    <a href={Redirects().homepage}>
                        <div className="btn_search ">
                            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                                viewBox="0 0 320 320">

                                <g>
                                    <path d="M269.7,76c-2.1,4.2-4.2,7.6-6.2,11.1L233,69.7v112.1h-8.3v-117l-65.1-37.4L94.6,64.9v117H87V69.7L56.5,87
		c-2.1-3.5-4.2-6.9-6.2-11.1l109.3-63l34.6,20.1V13h30.4v37.4L269.7,76z M156.2,139.6h-34.6v-22.8h34.6V139.6z M121.6,87h34.6v22.8
		h-34.6V87z M163.1,87h35.3v22.8h-35.3V87z M198.4,116.8v22.8h-35.3v-22.8H198.4z M73.1,213h173v-9h-173V213z M80.8,188.8h158.5v9
		H80.8V188.8z"/>
                                </g>
                                <g>
                                    <path class="st0" d="M111.2,252.4v40.5h-5.5v-18.4H83.9v18.4h-5.5v-40.5h5.5v18h21.8v-18H111.2z" />
                                    <path class="st0" d="M159,272.6c0,3-0.5,5.8-1.4,8.3c-1,2.5-2.3,4.7-4.1,6.5c-1.8,1.8-3.9,3.2-6.3,4.2s-5.2,1.5-8.1,1.5
		s-5.7-0.5-8.1-1.5c-2.4-1-4.5-2.4-6.3-4.2c-1.8-1.8-3.1-4-4.1-6.5c-1-2.5-1.4-5.3-1.4-8.3s0.5-5.8,1.4-8.3c1-2.5,2.3-4.7,4.1-6.5
		s3.8-3.3,6.3-4.3c2.4-1,5.2-1.5,8.1-1.5s5.7,0.5,8.1,1.5c2.5,1,4.6,2.4,6.3,4.3c1.8,1.8,3.1,4,4.1,6.5
		C158.5,266.8,159,269.6,159,272.6z M153.3,272.6c0-2.5-0.3-4.7-1-6.7c-0.7-2-1.6-3.6-2.9-5c-1.2-1.4-2.7-2.4-4.5-3.1
		c-1.8-0.7-3.7-1.1-5.9-1.1c-2.2,0-4.1,0.4-5.9,1.1c-1.8,0.7-3.3,1.8-4.5,3.1c-1.3,1.4-2.2,3-2.9,5c-0.7,2-1,4.2-1,6.7
		s0.3,4.7,1,6.7c0.7,2,1.6,3.6,2.9,5c1.3,1.4,2.8,2.4,4.5,3.1c1.8,0.7,3.7,1.1,5.9,1.1c2.2,0,4.2-0.4,5.9-1.1s3.3-1.8,4.5-3.1
		c1.2-1.4,2.2-3,2.9-5C153,277.3,153.3,275.1,153.3,272.6z"/>
                                    <path class="st0" d="M208.9,252.4v40.5h-4.8v-29.7c0-0.4,0-0.8,0-1.3c0-0.5,0.1-0.9,0.1-1.4l-13.9,25.3c-0.4,0.8-1.1,1.3-2,1.3
		h-0.8c-0.9,0-1.5-0.4-2-1.3l-14.2-25.4c0.1,1,0.2,1.9,0.2,2.8v29.7h-4.8v-40.5h4c0.5,0,0.9,0,1.1,0.1c0.3,0.1,0.5,0.4,0.8,0.8
		l14,24.9c0.2,0.5,0.4,0.9,0.7,1.4c0.2,0.5,0.4,1,0.6,1.5c0.2-0.5,0.4-1,0.6-1.5c0.2-0.5,0.4-1,0.7-1.4l13.7-24.9
		c0.2-0.4,0.5-0.7,0.7-0.8s0.7-0.1,1.1-0.1H208.9z"/>
                                    <path class="st0" d="M244.2,288.4l0,4.5h-24.9v-40.5h24.9v4.5h-19.5v13.4h15.8v4.3h-15.8v13.8H244.2z" />
                                </g>
                            </svg>

                        </div>

                    </a>
                </div>

                <MainBusinesses />
            </div>
        </>
    )
}

export default RequestResult;